import { render, staticRenderFns } from "./UserStats.vue?vue&type=template&id=75cd45ea&scoped=true"
import script from "./UserStats.vue?vue&type=script&lang=js"
export * from "./UserStats.vue?vue&type=script&lang=js"
import style0 from "./UserStats.vue?vue&type=style&index=0&id=75cd45ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cd45ea",
  null
  
)

export default component.exports